import { useCallback, useEffect, useRef } from "react";

const BATCH_DELAY = 250;

/** Collects rows that arrive one by one (live trades) and hands them over newest first, at most every 250 ms, so a busy stream re-renders the grid a few times a second rather than once per row. */
export const useRowBatcher = <T>(setRows: (rows: T[]) => void) => {
    const pending = useRef<T[]>([]);
    const timeout = useRef<NodeJS.Timeout>(undefined);

    useEffect(() => () => clearTimeout(timeout.current), []);

    return useCallback(
        (row: T) => {
            pending.current.unshift(row);
            if (timeout.current) return;
            timeout.current = setTimeout(() => {
                timeout.current = undefined;
                const rows = pending.current;
                pending.current = [];
                setRows(rows);
            }, BATCH_DELAY);
        },
        [setRows]
    );
};
